export const baseUrl = "https://decorador3d.gis.com.mx"
// export const baseUrl = "http://localhost:8080"
